/* SellEton: Globo option fixes, product pages only (2026-10-03).
   1) Quantity stepper: Globo "Mixed quantity" add-ons get a compact "Qty - 1 +" control,
      shown only after the item is ticked. Pure CSS; Globo keeps doing the pricing.
   2) Size sync: when a shopper changes a product option (for example Platform Size),
      the Empire theme updates the hidden variant field without firing "change", so
      Globo never re-checks its variant conditions (size-matched pit frames and ramps).
      This re-fires "change" on that field once the variant id has actually changed.
   Remove the include line in snippets/head.is-land.liquid to turn both off. */
(function () {
  if (window.__seGloboFixes) return; window.__seGloboFixes = true;

  var css =
    '.gpo-choicelist .gpo-ov-quantity{display:flex!important;align-items:center;width:auto!important;max-width:none;margin:6px 0 8px 34px;gap:0;background:none;border:0}' +
    '.gpo-choicelist .gpo-ov-quantity::before{content:"Qty";font-size:12px;font-weight:600;color:#262b33;margin-right:8px;letter-spacing:.02em}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button{display:inline-flex!important;align-items:center;justify-content:center;width:30px;min-width:30px;height:30px;padding:0;border:1px solid #c9d3e0;border-radius:0!important;background:#f3f6fa;color:#262b33;cursor:pointer;visibility:visible!important;opacity:1!important;font-size:16px;line-height:1;font-weight:600;box-sizing:border-box}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button:hover{background:#e3ebf5}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button svg{display:none!important}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button[name=minus]{border-radius:4px 0 0 4px!important}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button[name=plus]{border-radius:0 4px 4px 0!important}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button[name=minus]::before{content:"\\2212"}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__button[name=plus]::before{content:"+"}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__input{width:46px!important;min-width:46px;max-width:46px;height:30px!important;min-height:30px;padding:0!important;margin:0!important;border:1px solid #c9d3e0!important;border-left:0!important;border-right:0!important;border-radius:0!important;text-align:center;font-size:14px;background:#fff!important;-moz-appearance:textfield;box-shadow:none!important}' +
    '.gpo-choicelist .gpo-ov-quantity .quantity__input::-webkit-inner-spin-button,.gpo-choicelist .gpo-ov-quantity .quantity__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}' +
    '.gpo-choicelist input[type=checkbox]:not(:checked) ~ .gpo-ov-quantity{display:none!important}';
  var st = document.createElement('style'); st.id = 'se-globo-fixes'; st.textContent = css; document.head.appendChild(st);

  var SEL = '[data-product-form] [name=id]';
  var last = null;
  function idField() { return document.querySelector(SEL); }
  function sync() {
    var el = idField();
    if (!el || !el.value || el.value === last) return;
    last = el.value;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function init() { var el = idField(); last = el ? el.value : null; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.matches && t.matches(SEL)) return;
    if (t.closest('.gpo-element, .gpo-form__group')) return;
    if (t.closest('[data-product-form], .product-form, .options-selection')) {
      setTimeout(sync, 60); setTimeout(sync, 400);
    }
  }, true);
})();
